(function() {
  angular.module('cfn').factory('PersonGroup', PersonGroup);

  PersonGroup.$inject = ['dataSource.factory'];
  function PersonGroup(dataSource) {
    return dataSource('personGroup').getRestService();
  }
})();
